import { Injectable } from '@angular/core';
import { COMMON_CONSTANTS } from '../common/core/common.constants';
import { isNullOrUndefined } from 'src/app/services/utils';
@Injectable({
  providedIn: 'root'
})
export class DecodeParamsService {

  constructor() {
    //tslint:disable:no-empty
    //@ts-ignore
   }

  decodeBase64(input: string) {
    if (!isNullOrUndefined(input)) {
      if (input.includes(' ')) {
        input = (window.location.href).split('?uid=')[1];
      }
      const decodedStr = atob(input);
      const decodedparams = {};
      const tempObj = decodedStr.split('&');
      for (const tempObject of tempObj) {
        const val = tempObject.split('=');
        switch (val[0]) {
          case COMMON_CONSTANTS.BAN_NUMBER_KEY:
            decodedparams[COMMON_CONSTANTS.BAN_NUMBER_KEY] = val[1];
            break;
          case COMMON_CONSTANTS.ORG_ID_KEY:
            decodedparams[COMMON_CONSTANTS.ORG_ID_KEY] = val[1];
            break;
          case COMMON_CONSTANTS.RETURN_URL_SSP:
            decodedparams[COMMON_CONSTANTS.RETURN_URL_SSP] = decodeURIComponent(val[1]);
            break;
          case COMMON_CONSTANTS.USER_ID:
            decodedparams[COMMON_CONSTANTS.USER_ID] = val[1];
            break;
          case COMMON_CONSTANTS.FIRST_NAME:
            decodedparams[COMMON_CONSTANTS.FIRST_NAME] = val[1];
            break;
          case COMMON_CONSTANTS.LAST_NAME:
            decodedparams[COMMON_CONSTANTS.LAST_NAME] = val[1];
            break;
          case COMMON_CONSTANTS.LOGON_ROUTER_ID:
            decodedparams[COMMON_CONSTANTS.LOGON_ROUTER_ID] = val[1];
            break;
          case COMMON_CONSTANTS.ROLE_ID:
            decodedparams[COMMON_CONSTANTS.ROLE_ID] = val[1];
            break;
          case COMMON_CONSTANTS.MSISDN:
            decodedparams[COMMON_CONSTANTS.MSISDN] = val[1];
            break;
          case COMMON_CONSTANTS.AUTH_TYPE:
            decodedparams[COMMON_CONSTANTS.AUTH_TYPE] = val[1];
            break;
          case COMMON_CONSTANTS.TAB: 
            decodedparams[COMMON_CONSTANTS.TAB] = val[1];
            break;
        }
      }
      return decodedparams;
    } else {
      return input;
    }
  }
}
